import ProfilePageCard from './ProfilePageCard';

export default ProfilePageCard;
